/*
 * Payment plans tabs (snippets/product-payment-plans.liquid): Pay Now / Pay Monthly / HSA/FSA.
 * Click or arrow keys switch tabs; a highlight slides to the selected tab and only its panel is shown.
 */
(function () {
  if (window.paymentPlansInitialized) return;
  window.paymentPlansInitialized = true;

  const selectors = {
    root: '[data-payment-plans]',
    tab: '[data-payment-plans-tab]',
    panel: '[data-payment-plans-panel]',
    tablist: '[data-payment-plans-tabs]',
  };

  function selectTab(tab, focus) {
    const root = tab && tab.closest(selectors.root);
    if (!root) return;

    const tabs = Array.from(root.querySelectorAll(selectors.tab));
    tabs.forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', selected ? 'true' : 'false');
      other.setAttribute('tabindex', selected ? '0' : '-1');
    });

    // Slide the highlight to the selected tab
    const tablist = root.querySelector(selectors.tablist);
    if (tablist) tablist.style.setProperty('--active-index', String(Math.max(tabs.indexOf(tab), 0)));

    const panelId = tab.getAttribute('aria-controls');
    root.querySelectorAll(selectors.panel).forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });

    if (focus) tab.focus();
  }

  document.addEventListener('click', (event) => {
    const tab = event.target instanceof Element ? event.target.closest(selectors.tab) : null;
    if (tab) selectTab(tab, false);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target instanceof Element ? event.target.closest(selectors.tab) : null;
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const root = tab.closest(selectors.root);
    const tabs = root ? Array.from(root.querySelectorAll(selectors.tab)) : [];
    const index = tabs.indexOf(tab);
    if (index === -1 || !tabs.length) return;

    let next = index;
    if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;

    event.preventDefault();
    selectTab(tabs[next], true);
  });
})();
